import { SvgIcon, SvgIconProps } from "@mui/material";

export const PythonIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 18 20" {...props}>
			<g clip-path="url(#clip0_7739_11958)">
				<path
					d="M8.9694 0C4.7196 0 4.67395 1.81458 4.67395 2.18808C4.67395 2.75472 4.67395 4.455 4.67395 4.455H9.05122V5.13558C9.05122 5.13558 4.49362 5.13558 2.93531 5.13558C1.63456 5.13558 0 6.00552 0 9.86058C0 13.4017 1.27505 14.7712 2.56189 14.7712C2.94398 14.7712 4.09091 14.7712 4.09091 14.7712C4.09091 14.7712 4.09091 13.0135 4.09091 12.4087C4.09091 11.4203 4.53616 9.59058 6.61189 9.59058C9.21535 9.59058 9.87987 9.59058 10.9533 9.59058C11.5918 9.59058 13.3925 9.2853 13.3925 6.9975C13.3925 4.57614 13.3925 3.7773 13.3925 2.63808C13.3927 2.07054 13.3045 0 8.9694 0ZM6.55576 1.52442C6.99136 1.52442 7.34335 1.91142 7.34335 2.39076C7.34335 2.86974 6.99136 3.2571 6.55576 3.2571C6.12016 3.2571 5.76818 2.86992 5.76818 2.39076C5.76818 1.91142 6.12016 1.52442 6.55576 1.52442Z"
					fill="url(#paint0_linear_7739_11958)"
				/>
				<path
					d="M9.03068 19.8005C13.2785 19.8005 13.3314 17.9517 13.3314 17.6124C13.3314 17.0457 13.3314 15.3455 13.3314 15.3455H8.94886V14.6649C8.94886 14.6649 13.5359 14.6649 15.0648 14.6649C16.3753 14.6649 18.0001 13.7732 18.0001 9.93988C18.0001 5.74192 16.2757 5.0293 15.4382 5.0293C15.0559 5.0293 13.9092 5.0293 13.9092 5.0293C13.9092 5.0293 13.9092 6.86818 13.9092 7.3918C13.9092 8.38018 13.4786 10.2099 11.3882 10.2099C8.78473 10.2099 8.2012 10.2099 7.04659 10.2099C6.40971 10.2099 4.60742 10.5512 4.60742 12.803C4.60742 15.4085 4.60742 16.0907 4.60742 17.1624C4.60742 18.1038 5.1304 19.8005 9.03068 19.8005ZM11.4445 18.276C11.0089 18.276 10.6569 17.8889 10.6569 17.4097C10.6569 16.9305 11.0087 16.5434 11.4445 16.5434C11.8799 16.5434 12.2321 16.9305 12.2321 17.4097C12.2321 17.8889 11.8799 18.276 11.4445 18.276Z"
					fill="url(#paint1_linear_7739_11958)"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_7739_11958"
					x1="1.68685"
					y1="1.76872"
					x2="11.4874"
					y2="10.7081"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#387EB8" />
					<stop offset="1" stop-color="#366994" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_7739_11958"
					x1="7.12431"
					y1="8.07832"
					x2="17.586"
					y2="17.1899"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#FFE052" />
					<stop offset="1" stop-color="#FFC331" />
				</linearGradient>
				<clipPath id="clip0_7739_11958">
					<rect width="18" height="19.8" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};
